// extracted by mini-css-extract-plugin
export var actions = "_if-g";
export var benefitCard = "_if-b";
export var benefitIcon = "_if-d";
export var benefitLabel = "_if-f";
export var benefits = "_if-a";
export var benefitsSection = "_if-8";
export var bodyText = "_if-7";
export var closeButton = "_if-2";
export var content = "_if-3";
export var eyebrow = "_if-4";
export var heading = "_if-5";
export var image = "_if-i";
export var imagePanel = "_if-h";
export var modal = "_if-0";
export var offerCard = "_if-c";
export var offerIcon = "_if-e";
export var sectionLabel = "_if-9";
export var shell = "_if-1";
export var title = "_if-6";